<template>
  <ak-dropdown
    position-x="right"
    position-y="bottom"
    size="auto"
    aria-role="list"
    class="ml-auto"
  >
    <template #trigger>
      <ak-button size="tiny" color="primary">
        Create
        <ak-icon type="arrow-down-b" class="ml-tiny" />
      </ak-button>
    </template>
    <template #default>
      <ak-dropdown-item aria-role="listitem" @click="createProject">
        Projects
      </ak-dropdown-item>
      <ak-dropdown-item aria-role="listitem" @click="createFolder">
        Folder
      </ak-dropdown-item>
    </template>
  </ak-dropdown>
</template>

<script>
import { defineComponent } from 'vue'
import Dropdown from '@akerolabs/akero-vue/src/components/dropdown/Dropdown.vue'
import DropdownItem from '@akerolabs/akero-vue/src/components/dropdown/DropdownItem.vue'
import Button from '@akerolabs/akero-vue/src/components/button/Button.vue'
import Icon from '@akerolabs/akero-vue/src/components/icon/Icon.vue'

export default defineComponent({
  name: 'CreateDropdown',
  props: {
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },
  emits: ['createFolder', 'createProject'],
  setup(props, { emit }) {
    const createFolder = () => {
      emit('createFolder')
    }
    const createProject = () => {
      emit('createProject')
    }
    return {
      createFolder,
      createProject,
    }
  },
})
</script>
